// client/src/components/AppIcon.js
import React from 'react';
import { useUserPreferences } from '../contexts/UserPreferencesContext';

// Filled variants
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import ExtensionIcon from '@mui/icons-material/Extension';
import MovieIcon from '@mui/icons-material/Movie';
import AlbumIcon from '@mui/icons-material/Album';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CasinoIcon from '@mui/icons-material/Casino';
import ChatIcon from '@mui/icons-material/Chat';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import GroupIcon from '@mui/icons-material/Group';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FavoriteIcon from '@mui/icons-material/Favorite';
import StarIcon from '@mui/icons-material/Star';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';

// Outlined variants
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import DeveloperBoardOutlinedIcon from '@mui/icons-material/DeveloperBoardOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import AlbumOutlinedIcon from '@mui/icons-material/AlbumOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// Rounded variants
import SportsEsportsRoundedIcon from '@mui/icons-material/SportsEsportsRounded';
import DeveloperBoardRoundedIcon from '@mui/icons-material/DeveloperBoardRounded';
import ExtensionRoundedIcon from '@mui/icons-material/ExtensionRounded';
import MovieRoundedIcon from '@mui/icons-material/MovieRounded';
import AlbumRoundedIcon from '@mui/icons-material/AlbumRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';

const ICON_MAP = {
  SportsEsports:      { filled: SportsEsportsIcon,      outlined: SportsEsportsOutlinedIcon,      rounded: SportsEsportsRoundedIcon },
  DeveloperBoard:     { filled: DeveloperBoardIcon,     outlined: DeveloperBoardOutlinedIcon,     rounded: DeveloperBoardRoundedIcon },
  Extension:          { filled: ExtensionIcon,          outlined: ExtensionOutlinedIcon,          rounded: ExtensionRoundedIcon },
  Movie:              { filled: MovieIcon,              outlined: MovieOutlinedIcon,              rounded: MovieRoundedIcon },
  Album:              { filled: AlbumIcon,              outlined: AlbumOutlinedIcon,              rounded: AlbumRoundedIcon },
  MenuBook:           { filled: MenuBookIcon,           outlined: MenuBookOutlinedIcon,           rounded: MenuBookRoundedIcon },
  Casino:             { filled: CasinoIcon,             outlined: CasinoOutlinedIcon,             rounded: CasinoRoundedIcon },
  Chat:               { filled: ChatIcon,               outlined: ChatOutlinedIcon,               rounded: ChatRoundedIcon },
  BarChart:           { filled: BarChartIcon,           outlined: BarChartOutlinedIcon,           rounded: BarChartRoundedIcon },
  Settings:           { filled: SettingsIcon,           outlined: SettingsOutlinedIcon,           rounded: SettingsRoundedIcon },
  Person:             { filled: PersonIcon,             outlined: PersonOutlinedIcon,             rounded: PersonRoundedIcon },
  AdminPanelSettings: { filled: AdminPanelSettingsIcon, outlined: AdminPanelSettingsOutlinedIcon, rounded: AdminPanelSettingsRoundedIcon },
  Group:              { filled: GroupIcon,              outlined: GroupOutlinedIcon,              rounded: GroupRoundedIcon },
  Search:             { filled: SearchIcon,             outlined: SearchOutlinedIcon,             rounded: SearchRoundedIcon },
  Add:                { filled: AddIcon,                outlined: AddCircleOutlineIcon,           rounded: AddCircleRoundedIcon },
  Edit:               { filled: EditIcon,               outlined: EditOutlinedIcon,               rounded: EditRoundedIcon },
  Delete:             { filled: DeleteIcon,             outlined: DeleteOutlinedIcon,             rounded: DeleteRoundedIcon },
  Favorite:           { filled: FavoriteIcon,           outlined: FavoriteBorderIcon,             rounded: FavoriteRoundedIcon },
  Star:               { filled: StarIcon,               outlined: StarBorderIcon,                 rounded: StarRoundedIcon },
  Logout:             { filled: LogoutIcon,             outlined: LogoutIcon,                     rounded: LogoutRoundedIcon },
  Notifications:      { filled: NotificationsIcon,      outlined: NotificationsNoneIcon,           rounded: NotificationsRoundedIcon },
};

export default function AppIcon({ name, ...props }) {
  const { preferences } = useUserPreferences();
  const style = preferences?.iconStyle || 'filled';
  const variants = ICON_MAP[name];
  if (!variants) {
    console.warn(`AppIcon: unknown icon name "${name}". Add it to ICON_MAP in AppIcon.js`);
    return null;
  }
  const Icon = variants[style] || variants.filled;
  return <Icon {...props} />;
}
